
import MainBtn from "../../modules/Button/MainBtn";

import TeacherModul from "../../modules/TeacherCard/TeacherModule";
import './About.scss'
import ReviewsBlock from "../../modules/Reviews/ReviewsBlock";
import PhotoBlock from "../../modules/PhotoBlock/PhotoBlock";

import { Helmet } from 'react-helmet';
import FullAccordeon from "../../modules/Accordeon/FullAccorgeon";

export default function About(){



    return(
        <div className="About">
            <Helmet>
        <title>Про нас - Академія SmartumPro</title>
        <meta name="description" content="Академія розвитку інтелекту SmartumPro для дітей від 5 до 16 років. Ментальна арифметика, розвиток читання, англійська мова, ліберика, меморика, таблиця множення, підготовка до школи, математика, гармонійний розвиток півкуль, розвиток пам'яті." />
       
        {/* Соціальні прев'ю (опціонально) */}
        <meta property="og:title" content="Про нас - Академія SmartumPro" />
        <meta property="og:description" content="Академія розвитку інтелекту SmartumPro для дітей від 5 до 16 років. Ментальна арифметика, розвиток читання, англійська мова, ліберика, меморика, таблиця множення, підготовка до школи, математика, гармонійний розвиток півкуль, розвиток пам'яті." />
        <meta property="og:image" content="https://your-domain.com/img/preview.jpg" />
        <meta property="og:url" content="https://smartum-pro.com/about" />
       
      </Helmet>

            <div className="about-container">
                <img className="wave" src="./wave3.svg" alt="wave" />
                <h1 className="title">Про нас</h1>
                <div className="about_us">
                    <div className="title_block">
                        <h2 className='title'>Smartum - сучасна освіта для дітей, які прагнуть більшого!</h2>
                        <MainBtn text={"Записатись на заняття"} />
                    </div>
                    <div className="adventages">
                        <div className="adventage_item">
                            <h3>Ігрове навчання</h3>
                            <p className="adventage_text">Ігрове навчаня робить процес засвоєння знань цікавим і захопливим, підвищуючи мотивацію дітей.</p>
                        </div>
                        <div className="adventage_item">
                            <h3>Індивідуальний підхід</h3>
                            <p className="adventage_text">Індивідуальний підхід дозволяє враховувати особливості, темп і потреби кожної дитини, що робить навчання ефективнішим. </p>
                        </div>
                        <div className="adventage_item">
                            <h3>Навчальна платформа</h3>
                            <p className="adventage_text">Навчальна платформа допомагає відстежувати прогрес дитини й робить навчання цікавим та ефективним.</p>
                        </div>
                    </div>
                </div>
                <div className="gallery">
                    <h2 className='title'>Галерея</h2>

                    <PhotoBlock />
                     
                   
                </div>

               

                <div className="reviews">
                    <h2 className='title'>Відгуки</h2>
                     <ReviewsBlock />

                </div>

               

                <div className="team">
                    <h2 className='title'>Наша команда</h2>
                    <TeacherModul />
                </div>

                <div>
                    <h2 className='title'>Поширені запитання</h2>
                    <FullAccordeon />
                </div>
            </div>
        </div>

    )
}